module.exports = __webpack_public_path__ + "img/nopphasit.c453f0a3.jpg";